<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_Cabinent.id==0">فرم ثبت اطلاعات کمد</h5>
      <h5 class="card-title" *ngIf="inner_Cabinent.id>0">فرم ویرایش اطلاعات کمد</h5>
      <form [formGroup]="FormCabinet" (submit)="SubmitFormCabinet()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">محل</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">محل را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">شماره کد</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">شماره کد را وارد نمائید.</small>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && inner_Cabinent.id==0" type="submit" [disabled]="!FormCabinet.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button *ngIf="!InProccessing && inner_Cabinent.id>0" type="submit" [disabled]="!FormCabinet.valid" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش اطلاعات </button>

      </form>
  </div>
</div>
